customElements.define('ec-cpm-details', class extends HTMLElement {
  constructor() {
    super();
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this._handleToggle = this._handleToggle.bind(this);
  }

  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    if (!this.details || !this.summary) {
      console.error('ec-cpm-details requires a <details> and a <summary> element.');
      return;
    }

    const summaryId = this.summary.id;
    if (!summaryId) {
        console.error('ec-cpm-details: The <summary> element requires an ID to find its associated content via aria-labelledby.');
        return;
    }

    // Find content element as a sibling of <details> using aria-labelledby
    this.content = this.details.parentElement?.querySelector(`:scope > [aria-labelledby="${summaryId}"]`);


    if (!this.content) {
      console.warn(`ec-cpm-details: Could not find content element with aria-labelledby="${summaryId}" as a sibling of the <details> element.`);
      console.log('Summary element:', this.summary);
      console.log('Details element parent:', this.details.parentElement);
    }

    // Ensure initial state is set even if content wasn't found initially
    // (It might be added later, though this component doesn't handle that dynamically)
     this._updateState(this.details.open);

    // Add toggle listener only if essential elements are present
    this.details.addEventListener('toggle', this._handleToggle);
  }

  disconnectedCallback() {
    if (this.details) {
      this.details.removeEventListener('toggle', this._handleToggle);
    }
  }

  _handleToggle(event) {
    // Re-check for content element in case it was added dynamically,
    // though a MutationObserver would be more robust for dynamic content.
    if (!this.content && this.summary?.id && this.details?.parentElement) {
        const summaryId = this.summary.id;
        this.content = this.details.parentElement.querySelector(`:scope > [aria-labelledby="${summaryId}"]`);
    }
    this.dispatchEvent(new CustomEvent('ec-cpm-details-toggle', {
      detail: { open: event.target.open },
      bubbles: true,
      composed: true
    }));
    this._updateState(event.target.open);
  }

  _updateState(isOpen) {
    // Only try to update attributes if summary/content exist
    if (this.summary) {
        this.summary.setAttribute('aria-expanded', isOpen.toString());
    }
    if (this.content) {
      this.content.setAttribute('aria-hidden', (!isOpen).toString());
      if (isOpen) {
        this.content.removeAttribute('inert');
      } else {
        this.content.setAttribute('inert', '');
      }
    }
  }

  open() {
    if (this.details && !this.details.open) {
       this.details.setAttribute('open', '');
    }
  }

  close() {
    if (this.details && this.details.open) {
      this.details.removeAttribute('open');
    }
  }
});
